import { writeStorage } from "@rehooks/local-storage";

import { TENANT_KEY } from "../constants/index.ts";

/**
 * Mirrors the last tenant written in this tab.
 *
 * `writeStorage` falls back to memory when local storage is unavailable, which
 * happens in an embedded webview that blocks site data. A raw read then always
 * returns null. This value keeps every read and write consistent, so it must be
 * updated by every tenant write. Use `writeTenant` for all of them.
 */
let lastKnownTenant: string | null = null;

/** Reads the current tenant, through local storage or the in-tab mirror. */
export function readTenant(): string | null {
  try {
    return window.localStorage.getItem(TENANT_KEY) ?? lastKnownTenant;
  } catch {
    return lastKnownTenant;
  }
}

/**
 * Stores the tenant and notifies subscribers.
 *
 * Storage can fail, through a blocked webview or a full quota. The write must
 * not throw, because callers run inside a React effect and the app mounts no
 * error boundary.
 */
export function writeTenant(tenant: string): void {
  lastKnownTenant = tenant;

  try {
    writeStorage(TENANT_KEY, tenant);
  } catch (error) {
    console.warn("Failed to store the tenant", error);
  }
}
